/* unplugin-vue-components disabled */import { render } from "./user-cancelled.vue?vue&type=template&id=b414f61c&scoped=true"
import script from "./user-cancelled.vue?vue&type=script&lang=js"
export * from "./user-cancelled.vue?vue&type=script&lang=js"

import "./user-cancelled.vue?vue&type=style&index=0&id=b414f61c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b414f61c"],['__file',"src/components/ai-chat-v2/user-cancelled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b414f61c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b414f61c', __exports__)) {
    api.reload('b414f61c', __exports__)
  }
  
  module.hot.accept("./user-cancelled.vue?vue&type=template&id=b414f61c&scoped=true", () => {
    api.rerender('b414f61c', render)
  })

}


export default __exports__